module.exports = {"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Uyw4SP8XW6ZQz9FVPxcC1jMM5e-X3xUp_D0rcT3YSRA","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/kr/setting/contact/setting.json
// module id = 672
// module chunks = 0 1 2 3 4 5